import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, slicedToArray as _slicedToArray, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { animationDuration } from '../../styles/variables.js';
import { isTargetInsideContainer } from '../../utils/DomUtils.js';
import { reuseRef } from '../../utils/FunctionalHelpers.js';
import { Key } from '../../utils/Keys.js';
import { texts } from '../../utils/Localization.js';
import { TransitionHandler } from '../../utils/transition.js';
import { getInitialViewportSize, addViewportCallback, removeViewportCallback } from '../../utils/windowEvents/ResizeEvents.js';
import { LayerPresentation } from '../Layer/LayerPresentation.js';
import { FlyoutPresentation } from './FlyoutPresentation.js';

/*eslint-disable */
var FlyoutWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(FlyoutWrapper, _React$Component);
  var _super = _createSuper(FlyoutWrapper);
  function FlyoutWrapper(props) {
    var _this;
    _classCallCheck(this, FlyoutWrapper);
    _this = _super.call(this, props);
    _this.mobileViewports = ["sm", "xs"];
    _this.updateOpen = function (open) {
      _this.transitionHandler.transition(open, animationDuration.fastest, _this.state.transitionState, function (newState) {
        _this.setState({
          transitionState: newState
        });
      });
      // TODO: check if { capture: true } is required to prevent bugs with react >= 17
      document.removeEventListener("mousedown", _this.handleBodyClick);
      if (open) {
        document.addEventListener("mousedown", _this.handleBodyClick); // close if clicked outside select-flyout
      }
    };

    _this.handleBodyClick = function (ev) {
      if (!isTargetInsideContainer(ev.target, _this.getHostElement()) && !isTargetInsideContainer(ev.target, _this.props.toggleContainerElement || _this.props.toggleElement) && !(ev.target === _this.getHostElement())) {
        _this.close();
      }
    };
    _this.close = function () {
      var _a;
      _this.props.onClose();
      (_a = _this.props.toggleElement) === null || _a === void 0 ? void 0 : _a.focus();
    };
    _this.handleKeyDown = function (ev) {
      if (ev.key === Key.Escape) {
        _this.close();
      } else if (ev.key === Key.Tab && _this.props.hasTabIndex) {
        _this.props.onClose();
      } else {
        _this.props.onKeyDown(ev);
      }
    };
    _this.onViewportChanged = function (viewport) {
      return _this.setState({
        isMobile: _this.mobileViewports.includes(viewport)
      });
    };
    var _reuseRef = reuseRef(function () {
      return _this.props.hostRef;
    });
    var _reuseRef2 = _slicedToArray(_reuseRef, 2);
    _this.getHostRef = _reuseRef2[0];
    _this.getHostElement = _reuseRef2[1];
    _this.transitionHandler = new TransitionHandler();
    _this.state = {
      transitionState: _this.transitionHandler.makeTransitionState("unmounted"),
      setFocusOnOpen: false,
      isMobile: _this.mobileViewports.includes(getInitialViewportSize()),
      renderCounter: 0,
      hostWidth: 0
    };
    return _this;
  }
  _createClass(FlyoutWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateOpen(this.props.open);
      addViewportCallback(this.onViewportChanged);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // TODO: check if { capture: true } is required to prevent bugs with react >= 17
      document.removeEventListener("mousedown", this.handleBodyClick);
      this.transitionHandler.stopTransitions();
      removeViewportCallback(this.onViewportChanged);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props,
        open = _this$props.open,
        toggleElement = _this$props.toggleElement,
        noAutoFocus = _this$props.noAutoFocus,
        hasTabIndex = _this$props.hasTabIndex;
      if (open !== prevProps.open) {
        !noAutoFocus && this.setState({
          setFocusOnOpen: true
        });
        this.updateOpen(open);
        if (toggleElement && open) {
          var openTop = toggleElement.getBoundingClientRect().top + toggleElement.offsetHeight >= window.innerHeight * 0.7;
          this.setState({
            openTop: openTop
          });
        }
      }
      if (this.getHostElement() && this.state.transitionState.entering && !prevState.transitionState.entering && this.state.setFocusOnOpen && !noAutoFocus && hasTabIndex) {
        this.getHostElement().focus();
      }
      if (noAutoFocus && toggleElement) {
        toggleElement.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        transitionState = _this$state.transitionState,
        openTop = _this$state.openTop,
        isMobile = _this$state.isMobile,
        renderCounter = _this$state.renderCounter,
        hostWidth = _this$state.hostWidth;
      return this.props.isDrawerOnMobile && isMobile ? /*#__PURE__*/React.createElement(LayerPresentation, Object.assign({}, this.props, {
        closeLinkLabel: texts.lsg.component.ProfileWidget.closeMenu,
        layout: "right-25",
        open: this.props.open,
        onCloseClick: this.props.onClose,
        onBackdropClick: this.props.onClose,
        isMobile: isMobile
      })) : /*#__PURE__*/React.createElement(FlyoutPresentation, Object.assign({}, this.props, {
        renderCounter: renderCounter,
        forceRender: function forceRender(newRender) {
          return _this2.setState({
            renderCounter: newRender
          });
        },
        host: this.getHostElement(),
        transitionState: transitionState,
        onKeyDown: this.handleKeyDown,
        ref: this.getHostRef(),
        openTop: openTop,
        hostWidth: hostWidth,
        setHostWidth: function setHostWidth(newHostWidth) {
          return _this2.setState({
            hostWidth: newHostWidth
          });
        }
      }));
    }
  }]);
  return FlyoutWrapper;
}(React.Component);
FlyoutWrapper.defaultProps = {
  onKeyDown: function onKeyDown() {
    /* empty */
  },
  onClose: function onClose() {
    /* empty */
  },
  hasTabIndex: true,
  isDrawerOnMobile: false,
  noAutoFocus: false
};

export { FlyoutWrapper };
